






































































































































import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import {
  FraudCheckQueueDataOverride,
  AddressOverride,
} from "@/admin/types";
import VueRouter, { Location } from "vue-router";
import { Validator } from "vee-validate";
import AddressUpdate from "@/admin/components/utility/fraud/AddressUpdate.vue";
import moment from "moment";
import { useFraudCheckStore } from "@/admin/store/fraudcheck";

const emptyAddress = (): AddressOverride => ({
  address1: "",
  address2: "",
  city: "",
  state: "",
  zip: "",
  country: "United States of America"
});

const emptyData = (): FraudCheckQueueDataOverride => ({
  firstName: null,
  lastName: null,
  dateOfBirth: null,
  ssn: null,
  physicalAddress: emptyAddress(),
  mailingAddress: emptyAddress(),
  hubspotTicket: "",
  physicalAndMailingAreSame: true
});

@Component({
  components: {
    AddressUpdate,
  }
})
export default class DataOverride extends Vue {
  $validator: Validator;
  $router: VueRouter;
  xxxx = emptyData();
  overridePhysicalAddress = false;
  isSubmitting = false;

  fraudCheckStore = useFraudCheckStore();

  @Prop() queueId: number;

  @Prop() routeToFraudCheckList: () => Location;

  @Prop() areAddressesIdentical: boolean;

  created () {
    this.resetData();
  }

  get overrideMailingAddress () {
    return this.overridePhysicalAddress && !this.xxxx.physicalAndMailingAreSame;
  }

  set overrideMailingAddress (value: boolean) {
    this.xxxx.physicalAndMailingAreSame = !value;
  }

  @Watch("queueId")
  resetData () {
    this.xxxx = emptyData();
  }

  onSubmit () {
    if (this.isSubmitting) {
      return;
    }
    this.isSubmitting = true;

    this.$validator
        .validateScopes()
        .then(result => {
          if (!result) {
            return;
          }

          const dataOverride: FraudCheckQueueDataOverride & { queueId: number } = {
            queueId: this.queueId,
            hubspotTicket: this.xxxx.hubspotTicket,
            firstName: this.xxxx.firstName,
            lastName: this.xxxx.lastName,
            ssn: this.xxxx.ssn,
            dateOfBirth: this.xxxx.dateOfBirth ? moment(this.xxxx.dateOfBirth).format("MM/DD/YYYY") : null,
            physicalAddress: this.overridePhysicalAddress ? this.xxxx.physicalAddress : null,
            mailingAddress: this.overrideMailingAddress ? this.xxxx.mailingAddress : null,
            physicalAndMailingAreSame: this.xxxx.physicalAndMailingAreSame,
          };

          return this.fraudCheckStore.overrideUserData({
                queueId: this.queueId,
                dataOverride,
              })
              .then(_ => {
                this.$router.push(this.routeToFraudCheckList());
              });
        })
        .finally(() => {
          this.isSubmitting = false;
        });
  }

}
